import analyticsProviderFactory from './core/AnalyticsProviderFactory';
import SegmentProvider from './providers/SegmentProvider';

let isInitialized = false;

/* 

Function to initialize all providers. This function should be called once in the 
application to initialize all the providers.

*/
export function initializeAnalyticsProviders(): void {
  if (isInitialized) {
    return;
  }

  analyticsProviderFactory.registerProvider('segment', new SegmentProvider()); // Mark SegmentProvider as default
  isInitialized = true;

}

// Export all necessary modules
export { AnalyticsEvent } from './core/AnalyticsEvent';
export { default as analyticsProviderFactory } from './core/AnalyticsProviderFactory';